// @todo: effort minimal sur ce mapper, du fait que le Content Model est voué à disparaître au profit de Common Item.
import type { Asset } from '@b2ag/contentful'

import type { ContentMediaImage } from '../../../../content-media/domain/ContentMedia'
import type { Newsletter } from '../../../domain/Newsletter'
import type { NewsletterDTO } from '../../../domain/NewsletterDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'

import { assetDtoToUrl } from '../../../../../utils/asset-dto-to-url'
import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

const assetToContentMediaImage = (dto: Asset): ContentMediaImage => {
  return {
    id: assetDtoToUrl(dto) || '',
    contentType: ContentModelId.CONTENT_MEDIA,
    source: {
      desktop: assetDtoToUrl(dto),
    },
    type: 'image',
  }
}

export const mapNewsletterFromApi = (dto: NewsletterDTO): Newsletter | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const {
    content: description,
    ctaLabel: linkLabel,
    emailDefaultBody = '',
    emailSubject = '',
    image,
    receptionEmail,
  } = dto.fields

  const mediaImage = image && assetToContentMediaImage(image)
  const linkUrl = `mailto:${receptionEmail}?subject=${emailSubject}&body=${encodeURI(emailDefaultBody)}`

  return {
    contentType: ContentModelId.NEWSLETTER,
    description,
    media: mediaImage,
    linkLabel,
    linkUrl,
  }
}
